var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaccarat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2901:98624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 9.58804V8.58804H36.6666H27.2559H26.2559V8.95938H13.7446V8.58804H12.7446H3.33325H2.33325V9.58804V19.208V19.476L2.46726 19.7081L6.93326 27.4421L7.06725 27.6741L7.2993 27.8081L15.0426 32.2781L15.2747 32.412H15.5426H24.4606H24.7285L24.9605 32.2781L32.6979 27.8114L32.9299 27.6775L33.0639 27.4455L37.5325 19.7082L37.6666 19.4761V19.208V9.58804ZM14.7705 24.1214L14.1199 25.2481L13.9073 25.1253L14.5579 23.9987L14.7705 24.1214ZM20.1226 25.49V26.7914H19.8779V25.49H20.1226ZM25.2293 24.1214L25.4419 23.9987L26.0925 25.1253L25.8799 25.2481L25.2293 24.1214ZM29.1807 20.2601L29.3032 20.0481L30.4298 20.6986L30.3074 20.9107L29.1807 20.2601ZM22.5073 14.3834V15.2194H17.4919V14.3834H22.5073ZM9.57002 20.6986L10.6967 20.0481L10.8192 20.2601L9.69248 20.9107L9.57002 20.6986Z",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2901:98624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35,
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaccarat);
export default __webpack_public_path__ + "static/media/baccarat.9eeb9feddb5e96a528eb825dd5b3eeb3.svg";
export { ForwardRef as ReactComponent };